import { GustInformationFormWrapper, PhoneInputWrapper } from "./styles";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import UserOctagonIcon from "@assets/svg/UserOctagonIcon.svg?react";
import Input from "@Common/input";
import { PhoneNumberField } from "@Common/PhoneNumberField";
import { IFormManualReservation } from "..";
import { FORM_REGEX_VALIDATORS, isValidPhone } from "@utils";

export default function GustInformationForm() {
  /* ---------------------------------- Hooks --------------------------------- */
  const { t } = useTranslation();
  const { watch, control } = useFormContext<IFormManualReservation>();
  const isUserPaymentActiveWatch = watch(
    "booking_information.isUserPaymentActive"
  );
  /* --------------------------------- Effects -------------------------------- */

  return (
    <GustInformationFormWrapper>
      <div className="containerItem">
        <div className="containerSVG">
          <UserOctagonIcon />
        </div>
        <p>{t("MANUALRESERVATION.GUESTDATA")}</p>
        <Input
          name="gust_information.firstName"
          label={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
          placeholder={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSFIRSTNAME"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.textOnly,
              message: t("MANUALRESERVATION.ACCEPTTEXTONLY"),
            },
          }}
        />
        <Input
          name="gust_information.lastName"
          label={t("MANUALRESERVATION.LASTNameOfTheGuest")}
          placeholder={t("MANUALRESERVATION.LASTNameOfTheGuest")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSLASTNAME"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.textOnly,
              message: t("MANUALRESERVATION.ACCEPTTEXTONLY"),
            },
          }}
        />
        <PhoneInputWrapper>
          <Controller
            name="gust_information.guestPhoneNumber"
            control={control}
            rules={{
              required: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBER"),
              validate: (v) =>
                isValidPhone(v) ||
                t("MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBERCORRECTLY"),
            }}
            render={({
              field: { value, onChange, onBlur },
              fieldState: { error },
            }) => (
              <PhoneNumberField
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                required
                label={t("MANUALRESERVATION.GUESTMOBILENUMBER")}
                placeholder={t("MANUALRESERVATION.GUESTMOBILENUMBER")}
                error={error?.message ? t(error.message) : undefined}
              />
            )}
          />
        </PhoneInputWrapper>

        <Input
          name="gust_information.guestEmail"
          label={t("MANUALRESERVATION.GUEST_EMAIL")}
          placeholder={t("MANUALRESERVATION.GUEST_EMAIL")}
          registerOptions={{
            required: {
              value: true,
              message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSEMAIL"),
            },
            pattern: {
              value: FORM_REGEX_VALIDATORS.email,
              message: t(
                "MANUALRESERVATION.PLEASEENTERTHEGUESTSEMAILCORRECTLY"
              ),
            },
          }}
        />
      </div>
    </GustInformationFormWrapper>
  );
}
